import { useEffect } from 'react';
import { useQuery } from 'react-query';

import { isForbiddenError, isNotFoundError } from 'core/api';
import { useNotifications } from 'core/notifications';
import { PAGE_ERROR_TYPE, usePageError } from 'core/pageError';

const useAppQuery = (queryKey, queryFn, options = undefined) => {
  const queryResult = useQuery(queryKey, queryFn, options);

  const { showErrorNotification } = useNotifications();

  const { setError: setPageError } = usePageError();

  useEffect(() => {
    if (queryResult.isError) {
      if (isNotFoundError(queryResult.error) || isForbiddenError(queryResult.error)) {
        setPageError(PAGE_ERROR_TYPE.notFound);
      } else {
        showErrorNotification();
      }
    }
  }, [queryResult.isError, queryResult.error]);

  return queryResult;
};

export default useAppQuery;
